import React, { Fragment, useState } from 'react';
import { Modal } from 'antd';

const ImgView = ({ fileInfo, width, height, detailFileInfo, viewGlass, iconChnage }) => {
  const [previewVisible, setPreviewVisible] = useState(false);

  return (
    fileInfo &&  (
      <Fragment>
        <img
          alt={encodeURIComponent(fileInfo.fileName)}
          style={{ width: width || '100%', height: height || '100%'}} 
          src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(fileInfo.fileName)}&serverSubPath=${fileInfo.serverSubPath}&physicalName=${fileInfo.physicalName}`}
        />
        {viewGlass === true && 
        (iconChnage === true 
          ? <div 
              className="img-magnifier"
              onClick={()=>setPreviewVisible(true)}
            >
              <div style={{ 
                  display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '30px' 
                }}>
                <img
                  alt={'상세보기'}
                  src={require('../../../img/search_Icon.png')}
                  style={{width: '40%', height: '40%'}}
                />
              </div>
            </div>
          : <span 
              className="glass_img" 
              role="img" 
              aria-label="d"
              onClick={()=>setPreviewVisible(true)}
            > 🔍 </span>
        
        )}
        <Modal
          visible={previewVisible}
          title={fileInfo.fileName}
          className="modalContent"
          footer={null}
          onCancel={()=>setPreviewVisible(false)}
        >
          {detailFileInfo !== undefined && detailFileInfo !== null && detailFileInfo?.fileName
          ? <img
              alt={encodeURIComponent(detailFileInfo.fileName)}              
              style={{ width: '100%', height: '100%'}} 
              src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(detailFileInfo.fileName)}&serverSubPath=${detailFileInfo.serverSubPath}&physicalName=${detailFileInfo.physicalName}`} 
            />
          : <img
              alt={encodeURIComponent(fileInfo.fileName)}
              style={{ width: '100%'}} 
              src={process.env.REACT_APP_URL+`/file/imgView/?fileName=${encodeURIComponent(fileInfo.fileName)}&serverSubPath=${fileInfo.serverSubPath}&physicalName=${fileInfo.physicalName}`} 
            />
          }
        </Modal>
      </Fragment>
    )
  );
}

export default ImgView;
